import http from "../../http-common";

/**
 * API lịch sử tập trung của học sinh.
 * Backend trả về data là mảng sự kiện và total là tổng số dòng.
 */
class KidsLifecycleService {
    search(params) {
        return http.get("/student/lifecycle/events", {params});
    }
}

export default new KidsLifecycleService();
